module.exports = __webpack_public_path__ + "img/65ne.c9dbede3.svg";